import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from 'react-bootstrap';
import { FaTimesCircle } from "react-icons/fa";
import './rejected-leave.css'; // Import the CSS file for styling
import LeaveLayout from '../../components/LeaveLayout.js';

const rowsPerPage = 10;

export default function RejectedLeave() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch rejected leaves on component mount
  useEffect(() => {
    const fetchRejectedLeaves = async () => {
      setLoading(true);
      try {
        const userId = localStorage.getItem('userId'); // Get userId from localStorage
        if (!userId) {
          console.log("User ID is not available in session storage");
          return;
        }

        const response = await fetch(`http://localhost:5544/api/leaves/rejected`, {
          method: 'GET',
          headers: {
            'userid': userId, // Pass the userId in headers
          },
        });

        const result = await response.json();

        if (response.ok) {
          setData(result.rejectedLeaves);
        } else {
          console.log(result.message);
        }
      } catch (error) {
        console.error('Error fetching rejected leaves:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedLeaves();
  }, [currentPage]); // Run effect when currentPage changes

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <LeaveLayout>
      <div>
        <h1 className="rejected-leave-header">
          <FaTimesCircle className="rejected-leave-icon" />
          Rejected Leaves
        </h1>
        <hr className="rejected-leave-divider" />
        <div className="rejected-leave-content">
          <div>
            <div className='entries-search-container' style={{ marginTop: 0 }}>
              <Row>
                <Col xs={12} md={6} className="d-flex align-items-center">
                  <Dropdown as={ButtonGroup}>
                    <Button variant="primary">Show Entries</Button>
                    <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                      <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={6} className="d-flex justify-content-end search-container">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="search-input"
                    />
                  </Form>
                </Col>
              </Row>
            </div>
            <div className="table-responsive">
              <table className='table table-striped rejected-leave-table'>
                <thead className="rejected-leave-table-header">
                  <tr>
                    <th>SR</th>
                    <th>Leave Type</th>
                    <th>Days</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="4" className="text-center">Loading...</td></tr>
                  ) : (
                    data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((item, index) => (
                      <tr key={item._id}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td> {/* Dynamic row number */}
                        <td>{item.leaveType}</td>
                        <td>{item.days}</td>
                        <td>{item.reason}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr className='rejected-leave-table-footer'>
                    <td>Total</td>
                    <td>-</td>
                    <td>{data.length}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
              <div className="containerrrr">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, data.length)} of {data.length} Entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right">
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage - 1);
                            }}
                          >
                            Previous
                          </a>
                        </li>
                        {pageRange().map(pageNumber => (
                          <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                            <a
                              href="/#"
                              className="page-link"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePageChange(pageNumber);
                              }}
                            >
                              {pageNumber}
                            </a>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(currentPage + 1);
                            }}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeaveLayout>
  );
}
